<template>
  <div role="main" class="home-main-wrap">
    <div class="content-header">
      <div class="container-fluid home-wide-container">
        <div class="home-head">
          <div class="home-ref-line">
            <span class="home-ref-strong">MIS ÓRDENES</span>
          </div>
          <h1 class="home-title">Gestión de Órdenes</h1>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid home-wide-container">
        <div class="row">
          <div class="col-md-12">
            <div class="card-body p-0">
              <div class="cot-filter-wrap mb-4">
                <div class="row g-2">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group mb-0 text-left">
                      <label class="text-muted small mb-1" for="filter-client">
                        <b>Empresa</b>
                      </label>
                      <input
                        id="filter-client"
                        type="text"
                        class="form-control"
                        placeholder="Buscar por nombre de empresa o razón social"
                        v-model="filters.client"
                        @input="handleClientInput"
                      />
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="form-group mb-0 text-left">
                      <label class="text-muted small mb-1" for="filter-year">
                        <b>Año</b>
                      </label>
                      <select
                        id="filter-year"
                        class="form-control"
                        v-model="filters.year"
                        @change="buscarOrdenes()"
                      >
                        <option value="">Todos</option>
                        <option
                          v-for="year in years"
                          :key="`year-${year}`"
                          :value="String(year)"
                        >
                          {{ year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="form-group mb-0 text-left">
                      <label class="text-muted small mb-1" for="filter-status">
                        <b>Estatus</b>
                      </label>
                      <select
                        id="filter-status"
                        class="form-control"
                        v-model="filters.status"
                        @change="buscarOrdenes()"
                      >
                        <option value="">Todos</option>
                        <option value="EN PROCESO">EN PROCESO</option>
                        <option value="FINALIZADA">FINALIZADA</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
                <p class="text-muted mt-2 mb-0">Cargando órdenes...</p>
              </div>
              <div v-else-if="cot.length > 0">
                <transition-group name="orders-fade" tag="div" appear>
                <div
                  v-for="(cot, index) in cot"
                  :key="cot.id || index"
                  class="card card-light card-outline mb-2 shadow-sm cot-card"
                  :style="orderTransitionStyle(index)"
                  @click="handleClickCotizacion(cot.id)"
                >
                  <div class="cot-card__content">
                    <div class="cot-card__left-group">
                      <div class="cot-card__icon-box">
                        <i class="fa-solid fa-file-invoice"></i>
                      </div>
                      <div class="cot-card__left">
                      <div class="cot-card__row">
                        <span class="cot-card__label" style="color: rgb(9, 47, 86)"
                          >Folio:</span
                        >
                        <span class="cot-card__value">{{ cot.folio }}</span>
                      </div>
                      <div class="cot-card__row">
                        <span class="cot-card__value cot-card__value--bold">{{ cot.name }}</span>
                      </div>
                      <div class="cot-card__row">
                        <span class="cot-card__label">
                          <i class="fa-solid fa-calendar" style="color: rgb(9, 47, 86)"></i>
                        </span>
                        <span class="cot-card__value_date">
                          {{ formatDate(cot.createdAt) }}
                        </span>
                      </div>
                      </div>
                    </div>
                    <div class="cot-card__right">
                      <span
                        class="cot-card__status"
                        :class="getStatusBadgeClass(cot.estatus)"
                      >
                        <span class="cot-card__status-dot"></span>
                        {{ cot.estatus }}
                      </span>
                    </div>
                  </div>
                </div>
                </transition-group>
              </div>
              <div v-else class="text-center p-3">
                <p class="text-muted">
                  No hay ordenes disponibles en este momento.
                </p>
              </div>
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";
import debounce from "lodash.debounce";

export default {
  name: "HomePage",
  data() {
    return {
      cot: [],
      years: [],
      yearRange: { min: null, max: null },
      loading: false,
      filters: {
        client: "",
        year: "",
        status: "",
      },
      debouncedBuscarOrdenes: null,
    };
  },
  methods: {
    formatDate(value) {
      if (!value) return "Sin fecha";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "Sin fecha";
      return new Intl.DateTimeFormat("es-MX", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async feed() {
      this.loading = true;
      try {
        const response = await axiosInstance.get("/users/feed");
        this.cot = response.data?.cotizaciones || [];
        this.years = response.data?.years || [];
        this.yearRange = response.data?.yearRange || { min: null, max: null };
      } catch (error) {
        console.error("Error al obtener datos del usuario:", error);
      } finally {
        this.loading = false;
      }
    },
    handleClickCotizacion(id) {
      const fromPath = this.$route.fullPath || "/home";
      localStorage.setItem("ordenDetalleBackLink", fromPath);
      this.$router.push({
        path: `/orden-detalle/${id}`,
        query: { from: fromPath },
      });
    },
    orderTransitionStyle(index) {
      const delay = Math.min(index * 35, 210);
      return { transitionDelay: `${delay}ms` };
    },
    getStatusBadgeClass(status) {
      const value = String(status || "").toUpperCase().trim();
      if (value === "FINALIZADA") return "cot-card__status--done";
      if (value === "EN PROCESO") return "cot-card__status--progress";
      return "";
    },
    async buscarOrdenes() {
      this.loading = true;
      try {
        const response = await axiosInstance.get("/users/filtros", {
          params: this.filters,
        });
        this.cot = response.data;
      } catch (error) {
        console.error("Error al buscar órdenes:", error);
      } finally {
        this.loading = false;
      }
    },
    handleClientInput() {
      this.debouncedBuscarOrdenes();
    },
  },
  created() {
    this.debouncedBuscarOrdenes = debounce(() => {
      this.buscarOrdenes();
    }, 300);
  },
  mounted() {
    this.feed();
  },
  beforeDestroy() {
    if (this.debouncedBuscarOrdenes?.cancel) {
      this.debouncedBuscarOrdenes.cancel();
    }
  },
};
</script>

<style>
.home-main-wrap {
  width: 100%;
}

.home-wide-container {
  width: 100%;
  max-width: 1500px;
  padding-left: 20px;
  padding-right: 20px;
}

.home-head {
  text-align: left;
  margin-bottom: 12px;
}

.home-ref-line {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  letter-spacing: 0.05em;
  margin-bottom: 1rem;
}

.home-ref-muted {
  color: #92a2b8;
  font-weight: 600;
}

.home-ref-sep {
  color: #9cafc7;
  font-weight: 700;
  transform: translateY(-1px);
}

.home-ref-strong {
  color: #0f2f5f;
  font-weight: 800;
}

.home-title {
  margin: 0;
  font-size: 56px;
  line-height: 1.05;
  color: #101e3d;
  font-weight: 800;
}

.cot-card {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  border: 1px solid #e3e8f0 !important;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(9, 47, 86, 0.06) !important;
  border-left: 4px solid #e3e8f0 !important;
  overflow: hidden;
}
.cot-card:hover {
  transform: translateY(-2px);
  border-color: #bfc7d1 !important;
  border-left-color: #0f4c96 !important;
  box-shadow: 0 12px 24px rgba(9, 47, 86, 0.12) !important;
}

.orders-fade-enter-active {
  transition: opacity 0.24s ease, transform 0.24s ease;
}

.orders-fade-enter {
  opacity: 0;
  transform: translateY(8px);
}

.orders-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
  position: relative;
}

.orders-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
.cot-card__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
}
.cot-card__left-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cot-card__icon-box {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e6f0fb;
}
.cot-card__icon-box i {
  color: #092f56;
  font-size: 20px;
}
.cot-card__left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.cot-card__row {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.cot-card__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #6c757d;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: left;
}
.cot-card__value {
  font-weight: 500;
  color: #2f2f2f;
  text-align: left;
}
.cot-card__value--bold {
  font-weight: 700;
}
.cot-card__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cot-card__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #0f5132;
  background: #d1e7dd;
}
.cot-card__status--done {
  color: #0f5132;
  background: #d1e7dd;
}
.cot-card__status--progress {
  color: #0b4b90;
  background: #dbeafc;
}
.cot-card__status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex: 0 0 auto;
}
.cot-card__value_date{
  color: #2f2f2f;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

.cot-filter-wrap {
  border: 1px solid #e3e8f0;
  border-radius: 14px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(9, 47, 86, 0.06);
  margin-bottom: 2rem;
}
.cot-filter-wrap .form-control {
  border-radius: 10px;
  border: 1px solid #d7e0ea;
  background: #ffffff;
}
.cot-filter-wrap .form-control:focus {
  box-shadow: 0 0 0 0.15rem rgba(9, 47, 86, 0.15);
  border-color: #092f56;
}

@media (max-width: 576px) {
  .home-ref-line {
    font-size: 12px;
  }
  .home-title {
    font-size: 36px;
  }
  .cot-card__content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .cot-card__left-group {
    width: 100%;
  }
  .cot-card__left {
    gap: 6px;
  }
  .cot-card__right {
    width: 100%;
    justify-content: flex-start;
  }
  .cot-card__status {
    font-size: 11px;
    padding: 5px 10px;
  }
}
</style>
